export const EMAIL_TEMPLATE_STATUS_OPTIONS = [
  { id: 'queued', label: 'Queued' },
  { id: 'running', label: 'Running' },
  { id: 'processing', label: 'Processing' },
  { id: 'completed', label: 'Completed' },
  { id: 'matched', label: 'Matched (uses Completed if empty)' },
  { id: 'failed', label: 'Failed' },
  { id: 'cancelled', label: 'Cancelled' },
];

/** Sample merge fields so the preview looks like a real message */
export const PREVIEW_SAMPLE_CONTEXT = {
  review_url: 'https://app.example.com/api/v1/orderx/public/review/demo-token?format=html',
  request_name: 'Sample RFQ — Package units',
  summary:
    'Request: Sample RFQ — Package units\nStatus: completed\nSubmitted by: j.doe\nLine items: 12',
  status: 'completed',
  user_id: 'j.doe',
  request_id: '10042',
  category: 'quote request',
};

export function substituteTemplateTokens(template, context) {
  let out = String(template ?? '');
  const ctx = context && typeof context === 'object' ? context : {};
  Object.entries(ctx).forEach(([key, val]) => {
    out = out.split(`{{${key}}}`).join(String(val ?? ''));
  });
  return out;
}

function escapeHtmlAttr(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

const BOOTSTRAP_CDN = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css';

/**
 * Full HTML document for iframe preview: grey “inbox” background + white message card.
 */
export function buildEmailPreviewSrcDoc({ bodyHtml, subjectLine }) {
  const sub = escapeHtmlAttr(substituteTemplateTokens(subjectLine, PREVIEW_SAMPLE_CONTEXT));
  const body = substituteTemplateTokens(bodyHtml, PREVIEW_SAMPLE_CONTEXT);
  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8"/>
  <meta name="viewport" content="width=device-width, initial-scale=1"/>
  <link rel="stylesheet" href="${BOOTSTRAP_CDN}" crossorigin="anonymous"/>
  <style>
    html, body { height: 100%; margin: 0; }
    body {
      background: linear-gradient(180deg, #dbeafe 0%, #f8fafc 40%);
      font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
      padding: 12px;
      box-sizing: border-box;
    }
    .og-mail-shell {
      max-width: 640px;
      margin: 0 auto;
    }
    .og-mail-meta {
      font-size: 12px;
      color: #64748b;
      margin-bottom: 10px;
      padding: 0 4px;
    }
    .og-mail-card {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 24px rgba(15, 23, 42, 0.12);
      padding: 28px 24px;
      min-height: 120px;
      border: 1px solid rgba(148, 163, 184, 0.35);
    }
    .og-mail-card img { max-width: 100%; height: auto; }
    .og-mail-card a { color: #2563eb; }
  </style>
</head>
<body>
  <div class="og-mail-shell">
    <div class="og-mail-meta"><strong>Subject:</strong> ${sub}</div>
    <div class="og-mail-card">${body || '<p class="text-muted mb-0">Empty body — add content in the visual editor.</p>'}</div>
  </div>
</body>
</html>`;
}
